module.exports = __webpack_public_path__ + "static/media/SERIEPG.93dd25bc.jpg";